import classNames from "classnames";
import React, { useState } from "react";
import style from "./style.scss";

import { Clickable } from "../../button/Clickable";
import { Tabs } from "../../nav/Tabs";
import { BoxContent } from "./BoxContent";
import { BoxTitle } from "./BoxTitle";

export const Box = ({ onClick, link, value, collapsable, onCollapseChange, fill, className, children, ...props }) => {
    const [collapsed, setCollapsed] = useState(props.collapsed || false);
    return React.createElement(
        !!link || !!onClick ? Clickable : "div",
        {
            className: classNames(
                style.base,
                {
                    [style.collapsed]: collapsed,
                    [style.clickable]: onClick || link,
                    [style.fill]: fill
                },
                className
            ),
            onClick: value ? () => onClick(value) : onClick,
            link: link
        },
        React.Children.toArray(children)
            .filter(Boolean)
            .map((child, index, visibleChildren) => {
                if (child.type === BoxTitle) {
                    return React.cloneElement(child, {
                        collapsed,
                        onToggleCollapse: collapsable
                            ? () => {
                                  setCollapsed(!collapsed);
                                  onCollapseChange && onCollapseChange(!collapsed);
                              }
                            : null
                    });
                } else if (child.type === Tabs) {
                    return React.cloneElement(child, {
                        mode: "box"
                    });
                } else if (child.type === BoxContent) {
                    return React.cloneElement(child, {
                        collapsed,
                        roundTop: index === 0,
                        roundBottom: index === visibleChildren.length - 1
                    });
                }
                return child;
            })
    );
};
